'use client';

import Image from 'next/image';
import { useState, type ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';

export function ProfileImageViewer({ src, name, kind, children, className }: {
  src: string; name: string; kind: 'photo' | 'banner'; children: ReactNode; className?: string;
}) {
  const label = kind === 'photo' ? 'profile photo' : 'profile banner';
  return <Dialog>
    <DialogTrigger asChild><button type="button" aria-label={`Enlarge ${label}`} title={`Enlarge ${label}`} className={cn('block cursor-zoom-in focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ring', className)}>{children}</button></DialogTrigger>
    <DialogContent className="max-h-[90dvh] w-[calc(100vw_-_2rem)] max-w-5xl overflow-y-auto" aria-describedby={undefined}><DialogHeader className="pr-8"><DialogTitle className="break-words leading-6">{name}’s {label}</DialogTitle></DialogHeader><EnlargedProfileImage key={src} src={src} alt={`${name}’s ${label}`} kind={kind} /></DialogContent>
  </Dialog>;
}

function EnlargedProfileImage({ src, alt, kind }: { src: string; alt: string; kind: 'photo' | 'banner' }) {
  const [failed, setFailed] = useState(false);
  return failed ? <div role="alert" className="flex min-h-48 items-center justify-center px-4 text-center text-sm text-muted-foreground">This image couldn’t be loaded. Close the viewer and try again.</div> : <Image unoptimized src={src} alt={alt} width={kind === 'photo' ? 1024 : 1600} height={kind === 'photo' ? 1024 : 500} className={cn('mx-auto max-h-[65dvh] object-contain', kind === 'photo' ? 'aspect-square w-[min(100%,65dvh)] rounded-[50%]' : 'w-full')} onError={() => setFailed(true)} />;
}
